import React from "react";

export default function IcCheckCircle24Px({ color = "#424242", ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={17}
      height={17}
      viewBox="0 0 17 17"
      {...restProps}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          fillRule="nonzero"
          d="M8.5 0A8.503 8.503 0 0 0 0 8.5C0 13.192 3.808 17 8.5 17S17 13.192 17 8.5 13.192 0 8.5 0z"
        />
        <path
          fill="#FFF"
          d="M6.8 12.75L2.55 8.5l1.199-1.199L6.8 10.345l6.452-6.451L14.45 5.1z"
        />
      </g>
    </svg>
  );
}
